import axiosInstance from '../axiosConfig';

export interface MessageTemplate {
    id: string;
    name: string;
    content: string;
    subject: string;
    type: 'INTRO' | 'THANKYOU' | 'EMAIL' | 'FRAGMENT';
}

const MESSAGE_TEMPLATE_API_URL = '/api/message-templates';

export const MessageTemplateService = {
    async fetchMessageTemplates(): Promise<MessageTemplate[]> {
        const response = await axiosInstance.get<MessageTemplate[]>(MESSAGE_TEMPLATE_API_URL);
        return response.data;
    },
    async editMessageTemplate(id: string, template: MessageTemplate): Promise<MessageTemplate> {
        const response = await axiosInstance.put<MessageTemplate>(`${MESSAGE_TEMPLATE_API_URL}/${id}`, template);
        return response.data;
    }
};
